import type { Chess, PieceSymbol, Square } from "chess.js";

type PromotionPiece = Extract<PieceSymbol, "q" | "r" | "b" | "n">;

export function moveFromUci(uci: string) {
  const promotion = uci.slice(4, 5) as PromotionPiece | "";
  return {
    from: uci.slice(0, 2) as Square,
    to: uci.slice(2, 4) as Square,
    promotion: promotion || undefined,
  };
}

export function replayUciMove(board: Chess, uci: string) {
  return board.move(moveFromUci(uci));
}

export function resolveUciMove(
  board: Chess,
  from: Square,
  to: Square,
  preferredPromotion: PromotionPiece = "q",
) {
  const candidates = board.moves({ square: from, verbose: true }).filter((move) => move.to === to);
  if (candidates.length === 0) {
    return null;
  }

  const selected =
    candidates.find((move) => move.promotion === preferredPromotion) ??
    candidates[0];

  return `${selected.from}${selected.to}${selected.promotion ?? ""}`;
}
